import { useEffect, useState } from "react";
import { LoanPortalSidebar } from "./components/LoanPortalSidebar";
import { LoanPortalDashboard } from "./LoanPortalDashboard";
import styles from "./LoanPortalLayout.module.css";
import { LoanPortalTopNav } from "./LoanPortalTopNav";

export type LoanPortalTab = "applications" | "services";

/**
 * Portal-only page composition.
 *
 * This owns the portal's internal top / side / main layout areas, but creates
 * no browser router and does not assume broader app-shell concerns. Standalone
 * Lending and a future Azul host both mount this through the route tree.
 */
export function LoanPortalLayout() {
  const [activeTab, setActiveTab] = useState<LoanPortalTab>("applications");

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const mql = window.matchMedia("(min-width: 768px)");
    const handleChange = () => {
      if (mql.matches) {
        setActiveTab("applications");
      }
    };

    handleChange();
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return (
    <div className={styles.page}>
      <LoanPortalTopNav />
      <div className={styles.body}>
        <div className={styles.contentContainer}>
          <LoanPortalDashboard activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
        <LoanPortalSidebar activeTab={activeTab} />
      </div>
    </div>
  );
}
